module.exports = __webpack_public_path__ + "static/media/LiveView4.568b3d5e.webp";